import React, { useState, useRef, useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import Classes from './RecordTable.module.css';
import DeleteConfirmPopup from '../../../../../GlobalComponents/DeleteConfirmPopup/DeleteConfirmPopup';
import backend from '../../../../../../api';

export default function MoreDropDown({ invoiceId, canEdit, canRefund, onView, onEdit, onRefund }) {
  const [dropDown, setDropDown] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(e) {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) setDropDown(false);
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const [openConfirmPopup, setOpenConfirmPopup] = useState(false);
  const [busy, setBusy] = useState(false);

  const handleDelete = async () => {
    try {
      setBusy(true);
      await backend.delete(`/api/invoices/${invoiceId}`);
      window.location.reload();
    } catch (e) {
      alert(e?.response?.data?.error || e.message);
    } finally {
      setBusy(false);
      setOpenConfirmPopup(false);
    }
  };

  return (
    <>
      <div className={Classes.dropDown} ref={dropdownRef}>
        <div className="flexAlign10 pointer mr10" onClick={() => setDropDown(!dropDown)}>
          <div className={Classes.dropdownIcon}>
            <svg xmlns="http://www.w3.org/2000/svg" height='15px' viewBox="0 0 128 512">
              <path d="M64 360a56 56 0 1 0 0 112 56 56 0 1 0 0-112zm0-160a56 56 0 1 0 0 112 56 56 0 1 0 0-112zM120 96A56 56 0 1 0 8 96a56 56 0 1 0 112 0z" />
            </svg>
          </div>
        </div>

        <AnimatePresence>
          {dropDown && (
            <motion.div
              initial={{ opacity: 0, y: -5 }} animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -5 }} transition={{ duration: 0.15 }}
              className={Classes.dropDownBody} style={{ top: '13px', right: '30px' }}
            >
              <div className={Classes.dropDownBodyInner}>
                <div className={Classes.dropDownElem} style={{ padding: '5px 10px' }} onClick={() => { setDropDown(false); onView?.(); }}>
                  <h5>View Invoice</h5>
                </div>
                <div className={Classes.dropDownLine}></div>
                <div
                  className={Classes.dropDownElem}
                  style={{ padding: '5px 10px', opacity: canEdit ? 1 : 0.5, pointerEvents: canEdit ? 'auto' : 'none' }}
                  onClick={() => { setDropDown(false); onEdit?.(); }}
                >
                  <h5>Edit Invoice</h5>
                </div>
                <div className={Classes.dropDownLine}></div>
                <div
                  className={Classes.dropDownElem}
                  style={{ padding: '5px 10px', opacity: canRefund ? 1 : 0.5, pointerEvents: canRefund ? 'auto' : 'none' }}
                  onClick={() => { setDropDown(false); onRefund?.(); }}
                >
                  <h5>Refund</h5>
                </div>
                <div className={Classes.dropDownLine}></div>
                <div
                  className={Classes.dropDownElem}
                  style={{ padding: '5px 10px', color: 'red' }}
                  onClick={() => { setDropDown(false); setOpenConfirmPopup(true); }}
                >
                  <h5>Delete</h5>
                </div>
              </div>
            </motion.div>
          )}
        </AnimatePresence>
        <input type="hidden" aria-label="Without label" readOnly />
      </div>

      <AnimatePresence>
        {openConfirmPopup && (
          <DeleteConfirmPopup
            handleClose={() => setOpenConfirmPopup(false)}
            handleSubmit={handleDelete}
            busy={busy}
          />
        )}
      </AnimatePresence>
    </>
  );
}
